import { LocalizationService } from '@abp/ng.core';
import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';

import { AiTestingStartedNotificationModel } from '../models/ai-testing-started-notification-model';
import { ToasterService } from '@abp/ng.theme.shared';
import { AiTestingDefinitionService } from 'src/app/ai-testing/proxy/ai-testing.service';

@Component({
  selector: 'cai-ai-testing-started-notification',
  templateUrl: './ai-testing-started-notification.component.html',
  styleUrls: ['./ai-testing-started-notification.component.scss'],
  standalone: false,
})
@NotificationType('AiTestingStartedNotification')
export class AiTestingStartedNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    try {
      this.notification = JSON.parse(data.payload);
    } catch {
      this.notification = null;
    }
  }

  notification: AiTestingStartedNotificationModel;

  constructor(
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
    private aiTestingService: AiTestingDefinitionService,
  ) {}

  showNotification(notification: NotificationModel) {
    try {
      this.notification = JSON.parse(notification.payload);
    } catch {
      return;
    }

    if (!this.notification) {
      return;
    }

    // Refresh the runs list if viewing the affected test
    this.aiTestingService.refreshRunsList$.next(this.notification.id);

    this.toasterService.info(
      this.localizationService.instant(
        'AiTesting::TestRunStartedWarning',
        this.notification.projectName,
        this.notification.name,
      ),
      null,
      { sticky: true },
    );
  }

  public getMessage(): string {
    if (!this.notification) {
      return '';
    }

    return this.localizationService.instant(
      'AiTesting::TestRunStartedWarning',
      this.notification.projectName,
      this.notification.name,
    );
  }
}
